import firebase from 'firebase'
import User from "./user.model";
import { AppService } from '../app.service';

export default class Component {

    constructor({ code, name, doc = null }) {
        this.doc = doc;
        this.code = code;
        this.name = name;
        this.timestamp = firebase.firestore.FieldValue.serverTimestamp();
        this.user = new User();
    }

    static list(callback) {
        AppService.allComponentsOnChange((snapshot) => {
            this.snapshot = snapshot;
            const list = [];
            snapshot.docs.forEach((item) => {
                const data = item.data();
                list.push(new Component({ ...data, doc: item }))
            })
            callback(list);
        });

    }

    static async saveLocal() {
        const resp = await Component.list();
        const localList = resp.map((item) => item.toJson());
        localStorage.setItem('localData', JSON.stringify(localList));
    }

    get id() {
        return this.doc ? this.doc.id : null;
    }

    toJson() {
        return {
            code: this.code,
            name: this.name,
            timestamp: this.timestamp,
            user: this.user.toJson()
        }
    }

    set({ code, name }) {
        this.code = code;
        this.name = name;
    }



    create() {
        return new Promise(async (resolve, reject) => {
            try {
                const component = await AppService.addComponent({
                    code: this.code,
                    name: this.name,
                    timestamp: this.timestamp,
                    uid: this.user.uid,
                    ...this.user.toJson()
                });
                this.doc = component;
                resolve({ component: this });
            } catch (error) {
                console.error("Error in Component.create", error);
                reject(error);
            }
        })
    }

    update() {
        return new Promise(async (resolve, reject) => {
            const data = { ...this.toJson() };
            debugger
            const resp = await this.doc.ref.update(data);
            resolve(resp);
        })
    }

    delete() {
        return this.doc.delete();
    }

}